module.exports = __webpack_public_path__ + "static/media/Left Lateral Cartoon.6c554442.png";